export interface OfficialImage {
  name: string;
  src: string;
  background: 'light' | 'dark';
  description?: string;
}

export interface OfficialImageCategory {
  id: string;
  title: string;
  description?: string;
  images: OfficialImage[];
}

/**
 * Official company imagery, grouped by category.
 * NOTE: logos and tagline lockups belong in the Logos tab, not here.
 * Drop new photography/assets into public/atek/branding/<category>/ and
 * register them in the matching category below.
 */
export const OFFICIAL_IMAGE_CATEGORIES: OfficialImageCategory[] = [
  {
    id: 'badges',
    title: 'Badges & certifications',
    description: 'Accreditation and partner badges.',
    images: [
      {
        name: 'A2LA Accredited',
        src: 'https://storage.googleapis.com/atek-public-assets/brand/logos/badge-a2la-accredited.png',
        background: 'light',
        description: 'ISO/IEC 17025 accreditation.',
      },
    ],
  },
  {
    id: 'photography',
    title: 'Photography',
    description: 'Team portraits, labs, and site imagery. (Pending upload.)',
    images: [],
  },
  {
    id: 'product',
    title: 'Product shots',
    description: 'Sensors, transmitters, gateways. (Pending upload.)',
    images: [],
  },
];
